/**
 * Socket.IO Configuration - Single Instance
 * Initialized once at app level
 * 
 * ✅ Uses same backend URL as axios (from config/api / REACT_APP_API_URL)
 */

import socketIO from 'socket.io-client';
import { getApiBaseUrl } from './api';

const isDev = process.env.NODE_ENV !== 'production';

// Same backend as axios (REACT_APP_API_URL or localhost)
const getSocketEndpoint = () => {
  const baseURL = getApiBaseUrl();
  if (isDev) console.log('🔌 Socket connecting to same URL as axios:', baseURL);
  return baseURL;
};

// Create socket instance ONCE - uses axios baseURL
export const socket = socketIO(getSocketEndpoint(), {
  // Prefer WebSocket but fall back to HTTP long-polling behind proxies that block WS upgrades.
  transports: ['websocket', 'polling'],
  secure: true,
  reconnection: true,
  path: '/socket.io/',
  withCredentials: true,
  // Never skip TLS verification in production (MITM risk). Dev-only escape hatch
  // for self-signed certs.
  rejectUnauthorized: !isDev,
  autoConnect: false, // Don't connect immediately - we'll connect in App.js
  query: {
    EIO: '4', // Explicitly set Engine.IO version
  },
});

// Socket connection management
export const connectSocket = () => {
  if (!socket.connected) {
    if (isDev) console.log('🔌 Connecting socket...');
    socket.connect();
  }
};

export const disconnectSocket = () => {
  if (socket.connected) {
    if (isDev) console.log('🔌 Disconnecting socket...');
    socket.disconnect();
  }
};

export default socket;



